
import { defineComponent } from "@vue/runtime-core";
import { computed, ComputedRef, PropType, ref, Ref } from "vue";
import { EnrolledTraining } from "../../../../domain/entities/entities";
import { formatTime } from "../../views/exercise/exercise_helpers";
import {
  formatMenusDates,
  formatMenusSchedule,
  formattedDuration,
  getMenusLocation
} from "../mixins";
import { wrapLoading } from "../../utils/wrap_loading";
import { dispatchError } from "../../utils/error_handling";
import { useStore } from "vuex";

const __default__ = defineComponent({
  name: "LineFaceTraining",
  methods: { formatMenusSchedule, formatMenusDates, getMenusLocation },
  props: {
    training: {
      type: Object as PropType<EnrolledTraining>,
      required: true
    }
  },
  setup(props) {
    const store = useStore();
    const image: Ref<string> = ref(`url(${props.training.imageURL})`);

    const certificateTraining: ComputedRef<string> = computed(
      () => store.getters["userProfile_module/certificateTraining"]
    );

    /** Checks if the course is active or not. */
    const isInactive = (training: EnrolledTraining): boolean => {
      const currentDate = new Date().toISOString().split("T")[0];

      if (!training.isActive) {
        return true;
      }

      return (
        currentDate < training.activationDate ||
        currentDate > training.inactivationDate
      );
    };

    const openCertificate = async (trainingID: number): Promise<void> => {
      try {
        if (isInactive(props.training)) return;

        if (props.training.certificatePath) {
          window.open(props.training.certificatePath, "_blank");
        } else {
          await generateCertificate(trainingID);
        }
      } catch (e) {
        await dispatchError(e);
      }
    };

    const generateCertificate = async (trainingID: number): Promise<void> => {
      await wrapLoading(async () => {
        await store.dispatch("userProfile_module/getCertificate", trainingID);
      }, "Gerando certificado...");

      window.open(certificateTraining.value, "_blank");
    };

    return {
      image,
      formatTime,
      isInactive,
      formattedDuration,
      openCertificate
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "78143ea8": (_ctx.image)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__